import { IActionContext } from '@msdyn365-commerce/core';
import { getAllOrgUnitLocationsByArea, GetAllOrgUnitLocationsByAreaInput } from '../../../actions/get-all-store-location-information';
export interface ICNCSelectedStore {
    productId: number;
    storeId: string;
}

export const setSelectedStore = (storeId: string, productId: number, ctx: IActionContext) => {
    const selectedStoresCookie = ctx.requestContext.cookies.get('selected_cnc_stores');
    if (selectedStoresCookie.value) {
        try {
            const selectedStores: ICNCSelectedStore[] = selectedStoresCookie.value as ICNCSelectedStore[];
            if (selectedStores && selectedStores.length) {
                const cncSelectedStore = selectedStores.find(ss => ss.productId === productId);
                if (cncSelectedStore) {
                    cncSelectedStore.storeId = storeId;
                    const updatedStores = selectedStores.filter(ss => ss.productId !== productId);
                    updatedStores.push(cncSelectedStore);
                    ctx.requestContext.cookies.set('selected_cnc_stores', updatedStores);
                    return;
                } else {
                    const cncStoreInfo: ICNCSelectedStore = { productId: productId, storeId: storeId };
                    selectedStores.push(cncStoreInfo);
                    ctx.requestContext.cookies.set('selected_cnc_stores', selectedStores);
                    return;
                }
            }
        } catch (e) {}
    }
    const selectedCNCStores: ICNCSelectedStore[] = [];
    const cncStoreInfo: ICNCSelectedStore = { productId: productId, storeId: storeId };
    selectedCNCStores.push(cncStoreInfo);
    ctx.requestContext.cookies.set('selected_cnc_stores', selectedCNCStores);
    return;
};

export const getSelectedStore = (productId: number, ctx: IActionContext) => {
    const selectedStoresCookie = ctx.requestContext.cookies.get('selected_cnc_stores');
    if (selectedStoresCookie.value) {
        try {
            const selectedStores: ICNCSelectedStore[] = selectedStoresCookie.value as ICNCSelectedStore[];
            if (selectedStores && selectedStores.length) {
                const cncSelectedStore = selectedStores.find(ss => ss.productId === productId);
                return cncSelectedStore?.storeId;
            }
        } catch (e) {
            return undefined;
        }
    }
    return undefined;
};

export const getOrgUnitLocObjSelected = async (productId: number, ctx: IActionContext) => {
    const storeId = getSelectedStore(productId, ctx);
    if (storeId) {
        const orgUnitLocationsInput = new GetAllOrgUnitLocationsByAreaInput(31.5070767, 74.4315609, 0, 0, false);
        const orgUnitLocations = await getAllOrgUnitLocationsByArea(orgUnitLocationsInput, ctx);
        return orgUnitLocations.find(loc => loc.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId === storeId);
    }
    return;
};
